export default __webpack_public_path__ + "static/media/summary.c45974a2.svg";